export default "__VITE_ASSET__nptSivHR__"